import { ThunkAction } from 'redux-thunk';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import * as FileSaver from 'file-saver';
import dayjs from 'dayjs';

import { EXPORT_INPROGRESS, EXPORT_SUCCESS, EXPORT_FAILURE } from './types';
import {
  CompanyService,
  NewsClientService,
  DraftCompanyService,
  TranscriptionsAdminService,
  TranscriptionsClientService,
} from '$/services';
import { toastError } from '$/store/toast/actions';

export const exportingAction = () => {
  return {
    type: EXPORT_INPROGRESS,
  };
};

export const exportSuccessAction = (payload: Blob) => {
  return {
    type: EXPORT_SUCCESS,
    payload,
  };
};

export const exportFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: EXPORT_FAILURE,
    payload: error,
    error: true,
  };
};

// thunk actions
export const exportNewsEarnings = (
    company?: Bixby.Models.CompanyExport
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async (dispatch, getState) => {
    dispatch(exportingAction());
    try {
      const companyId = company ? company.id : '';
      const timeframe = 'All';
      const newsTypeIds = (getState().newsFiltersState.data || []).map(_ => _.id);
      const timezone = dayjs.tz.guess();
      const blob = await NewsClientService.getNewsBlob(companyId, timeframe, newsTypeIds, timezone);
      dispatch(exportSuccessAction(blob));
      downloadFileInternal(blob, 'Bixby_News', 'docx');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportPortfolio =
  (myPortfolioEnabled: boolean): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const portfolioBlob = await CompanyService.exportPortfolio(myPortfolioEnabled);
      dispatch(exportSuccessAction(portfolioBlob));
      downloadFileInternal(portfolioBlob, 'Portfolio', 'xlsx');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportCompanyFinancials =
  (currentCompany: Bixby.Models.CompanyExport): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      let portfolioBlob: any = null;

      if (currentCompany.isDraft) {
        portfolioBlob = await DraftCompanyService.exportDraftFinancialStatements(currentCompany.id);
      } else {
        portfolioBlob = await CompanyService.exportFinancialModel(currentCompany.id);
      }

      dispatch(exportSuccessAction(portfolioBlob));
      downloadFileInternal(portfolioBlob, `${currentCompany.name}_Financials`, 'xlsx');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportTearSheet =
  (currentCompany: Bixby.Models.CompanyExport): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const tearSheetBlob: any = await CompanyService.exportTearSheet(currentCompany.id);

      dispatch(exportSuccessAction(tearSheetBlob));
      downloadFileInternal(tearSheetBlob, `${currentCompany.name}_Tearsheet`, 'pdf');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportPrimer =
  (currentCompany: Bixby.Models.CompanyExport): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const primerBlob: any = await CompanyService.exportPrimer(currentCompany.id);

      dispatch(exportSuccessAction(primerBlob));
      downloadFileInternal(primerBlob, `${currentCompany.name}_Primer`, 'pdf');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportHistoricalTearSheet =
  (companyId: string, companyName: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const tearSheetBlob: any = await CompanyService.exportHistoricalTearSheet(companyId);

      dispatch(exportSuccessAction(tearSheetBlob));
      downloadFileInternal(tearSheetBlob, `${companyName}_Tearsheet`, 'pdf');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const exportHistoricalPrimer =
  (companyId: string, companyName: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const primerBlob: any = await CompanyService.exportHistoricalPrimer(companyId);

      dispatch(exportSuccessAction(primerBlob));
      downloadFileInternal(primerBlob, `${companyName}_Primer`, 'pdf');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

  
  export const exportFinancialModel =
  (companyId: string, companyName: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const financialModelBlob: any = await CompanyService.exportFinancialModel(companyId);

      dispatch(exportSuccessAction(financialModelBlob));
      downloadFileInternal(financialModelBlob, `${companyName}_FinancialModel`, 'xlsx');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

  export const exportHistoricalFinancialModel =
  (companyId: string, companyName: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const historicalFinancialModelBlob: any = await CompanyService.exportHistoricalFinancialModel(companyId);

      dispatch(exportSuccessAction(historicalFinancialModelBlob));
      downloadFileInternal(historicalFinancialModelBlob, `${companyName}_FinancialModel`, 'xlsx');
    } catch (error: any) {
      dispatch(exportFailureAction(error));
    }
  };

export const downloadAdminTranscriptionAudio =
  (
    transcriptId: string,
    bixbyId: string,
    container: Bixby.Enums.TranscriptionContainer
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const blob = await TranscriptionsAdminService.downloadTranscriptionAudio(transcriptId, container);
      const downloadFileName = `${bixbyId}.mp3`;
      FileSaver.saveAs(blob, downloadFileName);
      dispatch(exportSuccessAction(blob));
    } catch (error: any) {
      dispatch(toastError('Failed to download transcript audio'));
      dispatch(exportFailureAction(error));
    }
  };

export const downloadClientTranscriptionAudio =
  (transcriptId: string, title: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const blob = await TranscriptionsClientService.downloadTranscriptionAudio(transcriptId);
      const downloadFileName = `${title}.mp3`;
      FileSaver.saveAs(blob, downloadFileName);
      dispatch(exportSuccessAction(blob));
    } catch (error: any) {
      dispatch(toastError('Failed to download transcript audio'));
      dispatch(exportFailureAction(error));
    }
  };

export const downloadAdminTranscriptionText =
  (
    transcriptId: string,
    bixbyId: string,
    container: Bixby.Enums.TranscriptionContainer
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const blob = await TranscriptionsAdminService.downloadTranscriptionText(transcriptId, container);
      const downloadFileName = `${bixbyId}.docx`;
      FileSaver.saveAs(blob, downloadFileName);
      dispatch(exportSuccessAction(blob));
    } catch (error: any) {
      dispatch(toastError('Failed to download transcript'));
      dispatch(exportFailureAction(error));
    }
  };

export const downloadClientTranscriptionText =
  (transcriptId: string, title: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(exportingAction());
    try {
      const blob = await TranscriptionsClientService.downloadTranscriptionText(transcriptId);
      const downloadFileName = `${title}.docx`;
      FileSaver.saveAs(blob, downloadFileName);
      dispatch(exportSuccessAction(blob));
    } catch (error: any) {
      dispatch(toastError('Failed to download transcript'));
      dispatch(exportFailureAction(error));
    }
  };

export const downloadFile =
  (
    blob: Blob,
    name: string,
    extension?: string,
    disableToast?: boolean
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    try {
      dispatch(exportingAction());
      const downloadFileName = extension ? `${name}.${extension}` : name;
      FileSaver.saveAs(blob, downloadFileName);
      if (!disableToast) {
        dispatch(exportSuccessAction(blob));
      }
    } catch (error: any) {
      if (!disableToast) {
        dispatch(toastError('Failed to download file'));
      }
      dispatch(exportFailureAction(error));
    }
  };

const downloadFileInternal = (downloadBlob: Blob, fileName: string, fileExtension?: string) => {
  const date = new Date().toLocaleDateString();
  const extension = fileExtension ? `.${fileExtension}` : '';
  const downloadFileName = `${fileName}_${date}${extension}`;
  FileSaver.saveAs(downloadBlob, downloadFileName);
};
